import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CopyPPhi, LinkPPHI, RedoPPhi } from "../../../assets/img/svg";
import { sendLink } from "../service/pphi";
import "./pphi.scss";

const PPHICollect = ({ enc_data, ppphiData, orderData, isPayButtonDisabled, handlePaynow, setIsPayButtonDisabled }) => {

    const [tncAccepted, setTncAccepted] = useState(false);
    const [showTnc, setShowTnc] = useState(false);

    useEffect(() => {
        // Ensure Pay Now is disabled until T&C is accepted
        setIsPayButtonDisabled(!tncAccepted);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tncAccepted]);

    const handleSendLink = () => {
        sendLink(enc_data);
    };

    const handleCopyLink = () => {
        navigator.clipboard
            .writeText(window.location.href)
            .then(() => {
                toast.success("Link copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const handleRefresh = () => {
        window.location.reload();
    };
    return (
        <div>
            <div className="row">
                <div className="details-wtrapper space-y-4">
                    <div className="detail-item flex items-center">
                        <span className="detail-span">
                            Premium Amount already Paid
                            <div
                                className="tooltip-container"
                                data-testid="tooltip-container"
                            >
                                <span className="info-icon-wrapper d-sm-block">
                                    <span className="info-icon">i</span>
                                </span>
                                <div className="tooltip d-sm-block">
                                    <div className="tooltip-c">
                                        <p>Total Amount </p>
                                        <p className="total-pphi">
                                            ₹{ppphiData.paid_amount}
                                        </p>
                                    </div>
                                    {ppphiData?.payment_history?.map(
                                        (ele) => (
                                            <div className="tooltip-c">
                                                <p>Payment Method {ele.mode}</p>
                                                <p className="payment-pphi">
                                                    {" "}
                                                    ₹{ele.amount}
                                                </p>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </span>
                        <h5 className="ml-auto text-lg font-semibold">
                            ₹
                            {ppphiData.paid_amount &&
                                ppphiData.paid_amount.toLocaleString(
                                    "en-IN"
                                )}
                        </h5>
                    </div>
                    <div className="detail-item flex items-center">
                        <span className="text-gray-600">
                            Amount Pending
                        </span>
                        <h5 className="ml-auto text-lg font-semibold">
                            ₹
                            {ppphiData.amount &&
                                ppphiData.amount.toLocaleString("en-IN")}
                        </h5>
                    </div>
                    <hr />

                    {/* Third-party declaration and T&C */}
                    <div className="detail-item pl-tnc flex">

                        <div className="pl-tnc__check d-flex align-items-start">
                            <input
                                id="tncCheckbox"
                                type="checkbox"
                                className="mt-1"
                                checked={tncAccepted}
                                onChange={(e) => setTncAccepted(e.target.checked)}
                            />
                            <p className="text-sm text-gray-700 mb-2 ">
                                I hereby confirm that I am the policy owner and declare that the premium of this policy is being paid from the income earned from legitimate funds and from a bank account/credit card which belongs to me in line with the regulatory requirement. I agree to the <button type="button" className="text-pink-600 underline pl-tnc__link" onClick={() => setShowTnc(true)}>Terms and conditions</button>
                            </p>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="detail-item">
                        <button className="trans-btn text-gray-500 flex items-center space-x-2">
                            <span></span>
                        </button>
                        {orderData?.order_data?.order_data?.status === "SUCCESS" ? (
                            <h3 className="text-green-600 font-bold">
                                PAYMENT SUCCESS
                            </h3>
                        ) : (
                            <>
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100 gap-3">
                                    <div className="text-start">
                                        {/* <p className="text-sm text-gray-600 mb-0">
                                            <strong>Note:</strong> Credit Card and Wallet payments may incur an additional convenience fee.
                                        </p> */}
                                    </div>
                                    <div className="d-flex gap-2">
                                        {ppphiData.view === "seller" && (
                                            <div className="d-flex">
                                                <span className="tooltipcell">
                                                    <button onClick={handleSendLink}>
                                                        <LinkPPHI />
                                                    </button>
                                                    <div>
                                                        <span className="tooltipcontent">
                                                            <div>Send Link</div>
                                                        </span>
                                                    </div>
                                                </span>
                                                <span className="tooltipcell">
                                                    <button onClick={handleCopyLink}>
                                                        <CopyPPhi />
                                                    </button>
                                                    <span className="tooltipcontent">
                                                        <div>Copy Link</div>
                                                    </span>
                                                </span>
                                                <span className="tooltipcell">
                                                    <button onClick={handleRefresh}>
                                                        <RedoPPhi />
                                                    </button>
                                                    <span className="tooltipcontent">
                                                        <div>Refresh Status</div>
                                                    </span>
                                                </span>
                                            </div>
                                        )}
                                        <button
                                            disabled={isPayButtonDisabled || !tncAccepted}
                                            className="pay-btn bg-pink-500 text-white px-4 py-2 rounded hover:bg-pink-600 disabled:opacity-50 disabled:cursor-not-allowed btn-pink"
                                            onClick={() => {
                                                handlePaynow();
                                                setIsPayButtonDisabled(true);
                                            }}
                                        >
                                            PAY NOW
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* T&C Modal */}
            {showTnc && (
                <div className="fixed inset-0 z-50 flex items-center justify-center pl-modal">
                    <div className="absolute inset-0 bg-black opacity-50 pl-modal__overlay" onClick={() => setShowTnc(false)}></div>
                    <div className="relative bg-white rounded shadow-lg max-w-2xl w-full max-h-[80vh] overflow-auto p-6 z-10 pl-modal__content">
                        <h2 className="text-lg font-semibold mb-4 pl-modal__title">Terms and Conditions</h2>
                        <div className="space-y-4 text-sm text-gray-800 pl-modal__body">
                            <p>
                                In case you do not receive a payment confirmation message, kindly verify your bank account/credit card details. If your account is debited, then your transaction is executed successfully, and you need not reinitiate the same. Due to a technical / response issue, the confirmation may not have been received by you. Your payment will be reflected in your policy within 4 working days from the date of payment or on the due date, whichever is later. We request you to kindly check the status of the same and revert in case of any discrepancy.
                            </p>
                        </div>
                        <div className="mt-6 text-right pl-modal__footer">
                            <button className="px-4 py-2 bg-pink-500 text-white rounded hover:bg-pink-600 btn-pink" onClick={() => setShowTnc(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PPHICollect;